/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as KontoBestaetigenRouteImport } from './routes/konto.bestaetigen'
import { Route as KontoPasswortRouteImport } from './routes/konto.passwort'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const KontoBestaetigenRoute = KontoBestaetigenRouteImport.update({
  id: '/konto/bestaetigen',
  path: '/konto/bestaetigen',
  getParentRoute: () => rootRouteImport,
} as any)
const KontoPasswortRoute = KontoPasswortRouteImport.update({
  id: '/konto/passwort',
  path: '/konto/passwort',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/konto/bestaetigen': typeof KontoBestaetigenRoute
  '/konto/passwort': typeof KontoPasswortRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/konto/bestaetigen': typeof KontoBestaetigenRoute
  '/konto/passwort': typeof KontoPasswortRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/konto/bestaetigen': typeof KontoBestaetigenRoute
  '/konto/passwort': typeof KontoPasswortRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/privacy' | '/terms' | '/konto/bestaetigen' | '/konto/passwort'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/privacy' | '/terms' | '/konto/bestaetigen' | '/konto/passwort'
  id:
    | '__root__'
    | '/'
    | '/privacy'
    | '/terms'
    | '/konto/bestaetigen'
    | '/konto/passwort'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  KontoBestaetigenRoute: typeof KontoBestaetigenRoute
  KontoPasswortRoute: typeof KontoPasswortRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/konto/bestaetigen': {
      id: '/konto/bestaetigen'
      path: '/konto/bestaetigen'
      fullPath: '/konto/bestaetigen'
      preLoaderRoute: typeof KontoBestaetigenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/konto/passwort': {
      id: '/konto/passwort'
      path: '/konto/passwort'
      fullPath: '/konto/passwort'
      preLoaderRoute: typeof KontoPasswortRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  KontoBestaetigenRoute: KontoBestaetigenRoute,
  KontoPasswortRoute: KontoPasswortRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
